import React from 'react';
import BookCard from './BookCard';
import './Library.css';

const Library = () => {
  // Mock data for MP3s
  const books = [
    { id: 1, title: 'Introduction to React', author: 'Jane Doe', audioUrl: '#' },
    { id: 2, title: 'The Great Gatsby', author: 'F. Scott Fitzgerald', audioUrl: '#' },
    { id: 3, title: '1984', author: 'George Orwell', audioUrl: '#' },
    { id: 4, title: 'The Catcher in the Rye', author: 'J.D. Salinger', audioUrl: '#' },
    { id: 5, title: 'To Kill a Mockingbird', author: 'Harper Lee', audioUrl: '#' },
  ];

  return (
    <div className="library-container">
      <div className="book-grid">
        {books.map(book => (
          <BookCard key={book.id} book={book} />
        ))}
      </div>
    </div>
  );
};

export default Library;
